export default "__VITE_ASSET__DFIcuhl3__"